<template>
  <div class="box">
    <div class="main">
      <div class="information">
        当前就诊人：*成成
        <button>切换</button>
      </div>
      <van-cell-group>
        <van-cell title="004979-线上vip(男)" />
      </van-cell-group>
      <van-cell-group>
        <div class="time">
          <van-cell title="检查日期：" value="2020-02-20" />
        </div>
      </van-cell-group>
      <van-cell-group>
        <div class="color">
          <van-cell title="付款金额" value="￥3999.00" />
        </div>
      </van-cell-group>
    </div>
    <div class="footer">
      <van-button type="info" :round="true" size="small">确认付款</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'goPrevention',
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {
    onClickLeft() {},
    go() {
      this.$router.push('goPrevention')
    }
  }
}
</script>
<style scoped>
.time /deep/ .van-nav-bar .van-icon {
  color: rgb(102, 102, 102);
}
.time /deep/ .van-cell .van-cell__title {
  -webkit-box-flex: 0.25;
  -webkit-flex: 0.25;
  flex: 0.25;
  color: #969799;
}
.time /deep/ .van-cell .van-cell__value {
  -webkit-box-flex: 0.5;
  -webkit-flex: 0.5;
  flex: 0.5;
  color: #323233;
  text-align: left;
}
.color /deep/ .van-cell {
  font-size: 16px;
}
.color /deep/ .van-cell .van-cell__value {
  color: rgb(226, 109, 56);
}
.information {
  color: #ffffff;
  background-color: rgb(8, 112, 253);
  padding: 7px 10px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.information button {
  background-color: #ffffff;
  font-size: 18px;
  color: rgb(79, 188, 251);
  border: 1px solid rgb(8, 112, 253);
  border-radius: 20px;
}

.footer {
  width: 100vw;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  background-color: #ffffff;
}
.footer button {
  width: calc(100% - 40px);
  margin: 10px 20px 10px 20px;
}
</style>
